import { AxiosError } from 'axios'

import get from 'lodash/get'

import { AppError } from './AppError'

export const isAxiosError = (err: Error): boolean => err instanceof AxiosError
export const isAppError = (err: Error): boolean => err instanceof AppError

export function formatError(err: Error): Error {
  if (isAxiosError(err)) {
    return new AppError({
      name: err.name,
      status: get(err, ['response', 'status'], 404),
      error: get(err, ['response', 'data', 'error'], 'internal_server_error'),
      message: err.message,
    })
  }

  return new Error(err.message)
}

export function formatErrorMessage(error: Error): string {
  if (isAxiosError(error)) {
    return get(error, ['response', 'data', 'error'], 'internal_server_error')
  }

  if (isAppError(error)) {
    return get(error, 'error', 'internal_server_error')
  }

  return error.message
}
